import React, { useEffect, useMemo, useState } from "react";
import { getPageImages } from "../services/api";

const PagePicture = ({ desktopSlot, mobileSlot, className = "", alt = "页面图片" }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        let active = true;
        getPageImages().then(response => {
            if (active) setItems(Array.isArray(response?.data) ? response.data : []);
        }).catch(() => {
            if (active) setItems([]);
        });
        return () => { active = false; };
    }, []);

    const images = useMemo(() => Object.fromEntries(items.map(item => [item.slot, item.image_url])), [items]);
    const desktop = images[desktopSlot];
    const mobile = images[mobileSlot];
    const fallback = desktop || mobile;
    if (!fallback) return null;

    return (
        <picture className={className}>
            {mobile && <source media="(max-width: 767px)" srcSet={mobile} />}
            <img src={fallback} alt={alt} />
        </picture>
    );
};

export default PagePicture;
